import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { red, yellow, blue } from '@material-ui/core/colors';
import Slide from '@material-ui/core/Slide';
import Fade from '@material-ui/core/Fade';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';

import Question from './Question';
import AAPlayerWrapper from './AAPlayerWrapper';
import Feedback from './Feedback';

const styles = (theme) => ({
	root: {
		overflow: 'hidden'
	},
	hidden: {
		display: 'none'
	},
	answerContainer: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'row',
		margin: `0 ${theme.spacing.unit * 4}px ${theme.spacing.unit * 4}px`,
	},
	answerContainerLeft: {
		display: 'flex'
	},
	correctAnswerContainer: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'row',
		alignSelf: 'center'
	},
	correctAnswer: {
		padding: `0 ${theme.spacing.unit * 2}px`,
		display: 'flex',
		justifyContent: 'center',
		whiteSpace: 'nowrap',
		color: 'white',
		backgroundColor: blue[500],
		flexDirection: 'column'
	},
	triangle: {
		borderWidth: 21,
		borderColor: 'transparent',
		borderLeftColor: blue[500],
		borderStyle: 'solid'
	},
	answer: {
		fontWeight: 600,
		// display: 'flex',
		flex: 1,
		padding: theme.spacing.unit,
		paddingLeft: 0,
		'& span': {
			color: 'black'
		},
		'& span[data-bad]': {
			background: `${red[500]} !important`
		},
		'& span[data-soso]': {
			background: `${yellow[500]} !important`
		},
		'& span[data-ok]': {
			background: `${blue[200]} !important`
		},
		'& span[data-unknown]': {
			color: `${red[500]} !important`
		},
	},
});

class Item extends Component {
	render() {
		const { classes, index, visible, question, answer, answered, questionNum, showAnswer, markedText, audioEnabled, basePath, audioPrefix, itemIndex } = this.props;
		let text = markedText || answer;
		text = text.replace(/\(-\)/g, '<br>');

		return (
			<div className={classNames(classes.root, { [classes.hidden]: !visible })}>
				<Slide direction="right" timeout={answered ? 0 : 300} in={visible}>
					<Question text={question} questionNum={questionNum} />
				</Slide>
				<Fade direction="right" in={showAnswer} data-type="answerContainer">
					<div className={classes.answerContainer}>
						<div className={classes.answerContainerLeft}>
							<div className={classes.correctAnswerContainer}>
								<Typography
									variant="subheading"
									className={classes.correctAnswer}
								>
									Correct answer
								</Typography>
								<div className={classes.triangle} />
							</div>
						</div>
						<Typography
							data-type="answer"
							variant="subheading"
							dangerouslySetInnerHTML={{ __html: text }}
							className={classes.answer}
						/>
					</div>
				</Fade>
				<AAPlayerWrapper itemIndex={index} listenPath={audioEnabled ? `${basePath}audio/${audioPrefix}${itemIndex + 1}.mp3` : null} />
				<Feedback answered={answered} />
			</div>
		);
	}
}

Item.propTypes = {
	classes: PropTypes.object.isRequired,
	question: PropTypes.string.isRequired,
	answer: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	visible: PropTypes.bool.isRequired,
	answered: PropTypes.bool.isRequired,
	showAnswer: PropTypes.bool.isRequired,
	questionNum: PropTypes.number,
	markedText: PropTypes.string,
	audioPrefix: PropTypes.string.isRequired,
	audioEnabled: PropTypes.bool.isRequired,
	basePath: PropTypes.string.isRequired,
	itemIndex: PropTypes.number.isRequired,
};

Item.defaultProps = {
	questionNum: undefined,
	markedText: undefined
};

function mapStateToProps({
	exercise: { currentItem, autoNum, questionsAnswered, itemsMarkedText, audioPrefix, audioEnabled },
	loader: { testMode, testSent, basePath }
}, ownProps) {
	const answered = Boolean(questionsAnswered[ownProps.index] === true) || testSent;

	return {
		audioEnabled,
		audioPrefix,
		basePath,
		visible: currentItem === ownProps.index,
		answered,
		showAnswer: answered && (!testMode || testSent),
		questionNum: autoNum ? ownProps.index + 1 : undefined,
		markedText: itemsMarkedText[ownProps.index]
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(Item);
